export default {
	customerinfo: {
		id: '238628232629321728',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '客户信息',
		type: 1,
		englishName: 'customerInfo',
		permissionId: '238628401529749504',
		sort: 1,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	customer: {
		code: 'iglobalwin',
		englishName: 'customerList',
		id: '238628358462636032',
		label: '',
		name: '客户列表',
		oftenFlag: 0,
		parentId: '238628232629321728',
		permissionId: '238628406386753536',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	accountAffirm: {
		code: 'iglobalwin',
		englishName: 'custtomerAffirm',
		id: '238629626564313088',
		label: '',
		name: '客户列表-客户确认',
		oftenFlag: 0,
		parentId: '238628358462636032',
		permissionId: '238630718861737984',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
	downloadRenewalRateReport: {
		id: '263272656621535232',
		code: 'iglobalwin',
		parentId: '238628358462636032',
		name: '客户列表-下载续费率报告',
		type: 3,
		englishName: 'downloadRenewalRateReport',
		permissionId: '264070400177078272',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	systemAccess: {
		id: '288726643457916928',
		code: 'iglobalwin',
		parentId: '238628358462636032',
		name: '客户列表-系统访问权限',
		type: 3,
		englishName: 'systemAccess',
		permissionId: '288726710201876480',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	resultsReport: {
		code: 'iglobalwin',
		englishName: 'resultsReport',
		id: '246620753645010944',
		label: '',
		name: '成效报告',
		oftenFlag: 0,
		parentId: '238628232629321728',
		permissionId: '246621006469267456',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	resultsReportCheckReport: {
		code: 'iglobalwin',
		englishName: 'resultsReportCheckReport',
		id: '246621342240079872',
		label: '',
		name: '成效报告-查看报告',
		oftenFlag: 0,
		parentId: '246620753645010944',
		permissionId: '246621717814837248',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
	setting: {
		id: '386170414964943652',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '设置',
		type: 1,
		englishName: 'setting',
		permissionId: '132179282632900608',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	website: {
		id: '386170414964943649',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '客户数据',
		type: 1,
		englishName: 'website',
		permissionId: '132179292997025792',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	flowAnalysis: {
		id: '386170414964943649',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '客户数据',
		type: 1,
		englishName: 'flowAnalysis',
		permissionId: '132179292997025792',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	websiteList: {
		id: '386170414964943650',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '网站管理',
		type: 2,
		englishName: 'websiteList',
		permissionId: '132179296218251264',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	website_report: {
		id: '386170414964943651',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '网站数据',
		type: 2,
		englishName: 'websiteReport',
		permissionId: '132179294674747392',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	googleReport: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '广告报告',
		type: 2,
		englishName: 'googleReports',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	webSiteIndexData: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '网站索引',
		type: 2,
		englishName: 'webSiteIndexData',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	seoTakeDown: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: 'Site收录',
		type: 2,
		englishName: 'seoTakeDown',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	siteSeoAnalysis: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '站内SEO分析',
		type: 2,
		englishName: 'siteSeoAnalysis',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	myWebsiteMonitor: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '网站报告',
		type: 2,
		englishName: 'myWebsiteMonitor',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	keywordRanking: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '关键字排名',
		type: 2,
		englishName: 'keywordRanking',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},

	// 报告下载
	reportToDownload: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '报告下载',
		type: 2,
		englishName: 'reportToDownload',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	balanceMatching: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '余额匹配',
		type: 2,
		englishName: 'balanceMatching',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	templateDelete: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '系统模板-删除',
		type: 2,
		englishName: 'templateDelete',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	templateAdd: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '系统模板-新增',
		type: 2,
		englishName: 'templateAdd',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	templateEdit: {
		id: '223832931972415488',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '系统模板-修改',
		type: 2,
		englishName: 'templateEdit',
		permissionId: '223833450027679744',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	//
	//
	facebookReport: {
		id: '296609960744189952',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: 'Facebook广告报告',
		type: 2,
		englishName: 'facebookReport',
		permissionId: '296610352777396224',
		sort: 5,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	enquiryList: {
		id: '386170414964943646',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '询盘',
		type: 1,
		englishName: 'inquiry',
		permissionId: '132179301926699008',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	socialMedia: {
		id: '386170414964943642',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '社媒管理',
		type: 1,
		englishName: 'socialMediaManagement',
		permissionId: '132179310344667136',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	socialMedialAuth: {
		id: '386170414964943645',
		code: 'iglobalwin',
		parentId: '386170414964943642',
		name: '授权管理',
		type: 2,
		englishName: 'authorizationManagement',
		permissionId: '132179311657484288',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	socialMedialAccount: {
		id: '386170414964943643',
		code: 'iglobalwin',
		parentId: '386170414964943642',
		name: '社媒账号',
		type: 2,
		englishName: 'socialMediaAccount',
		permissionId: '132179316388659200',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	chatSet: {
		code: 'iglobalwin',
		englishName: 'chatSet',
		id: '505340348067741696',
		label: '',
		name: '即时聊天配置',
		oftenFlag: 0,
		parentId: '386170414964943642',
		permissionId: '505341468655747072',
		positionId: '395203283951554560',
		sort: 1,
		type: 2,
	},
	chat: {
		code: 'iglobalwin',
		englishName: 'chat',
		id: '505340348067741696',
		label: '',
		name: '即时聊天',
		oftenFlag: 0,
		parentId: '386170414964943642',
		permissionId: '505341468655747072',
		positionId: '395203283951554560',
		sort: 1,
		type: 2,
	},
	task: {
		id: '386170414964943638',
		code: 'iglobalwin',
		parentId: '386170414964943631',
		name: '任务管理',
		type: 1,
		englishName: 'taskManagement',
		permissionId: '132179322562674688',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	taskReport: {
		id: '386170414964943641',
		code: 'iglobalwin',
		parentId: '386170414964943638',
		name: '任务统计',
		type: 2,
		englishName: 'taskStatistical',
		permissionId: '132179324236201984',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	taskBoard: {
		id: '386170414964943639',
		code: 'iglobalwin',
		parentId: '386170414964943638',
		name: '任务看板',
		type: 2,
		englishName: 'taskKanban',
		permissionId: '132179327360958464',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	taskList: {
		id: '386170414964943640',
		code: 'iglobalwin',
		parentId: '386170414964943638',
		name: '任务列表',
		type: 2,
		englishName: 'taskList',
		permissionId: '204948400360128512',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	socialMedialTweets: {
		id: '386170414964943644',
		code: 'iglobalwin',
		parentId: '386170414964943642',
		name: '推文管理',
		type: 2,
		englishName: 'tweetsManagement',
		permissionId: '204948458564485120',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	taskflow: {
		id: '386170414964943653',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '任务流配置',
		type: 2,
		englishName: 'taskFlowConfiguration',
		permissionId: '204948569906479104',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	versionControl: {
		id: '258619890213060608',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '客户端设置',
		type: 2,
		englishName: 'versionControl',
		permissionId: '258619964074754048',
		sort: 1,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	couponControl: {
		id: '319210437008687104',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '优惠券管理',
		type: 2,
		englishName: 'couponControl',
		permissionId: '319438444537315328',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	emailHost: {
		id: '319210437008687104',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '邮箱host配置',
		type: 2,
		englishName: 'emailHost',
		permissionId: '319438444537315328',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	welcomePage: {
		id: '319210437008687104',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '欢迎页配置',
		type: 2,
		englishName: 'welcomePage',
		permissionId: '319438444537315328',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	visitorDiscern: {
		id: '319895013951537152',
		code: 'iglobalwin',
		parentId: '386170414964943649',
		name: '网站访客识别',
		type: 2,
		englishName: 'visitorDiscern',
		permissionId: '319895172324261888',
		sort: 6,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	saas: {
		id: '266292700834168832',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '套餐与功能配置',
		type: 2,
		englishName: 'saas',
		permissionId: '266292760196153344',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	garbageInquiryFilter: {
		id: '289096876244860928',
		code: 'iglobalwin',
		parentId: '386170414964943652',
		name: '垃圾询盘',
		type: 2,
		englishName: 'garbageInquiryFilter',
		permissionId: '289096924659712000',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	enquiry: {
		id: '386170414964943647',
		code: 'iglobalwin',
		parentId: '386170414964943646',
		name: '询盘列表',
		type: 2,
		englishName: 'inquiryList',
		permissionId: '204984726518235136',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	enquiryStatistic: {
		id: '386170414964943648',
		code: 'iglobalwin',
		parentId: '386170414964943646',
		name: '询盘统计',
		type: 2,
		englishName: 'inquiryStatistics',
		permissionId: '204984735099781120',
		sort: 0,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	inquiryListViewAll: {
		id: '202804680240136192',
		code: 'iglobalwin',
		parentId: '386170414964943647',
		name: '询盘列表-查看全部',
		type: 3,
		englishName: 'inquiryListViewAll',
		permissionId: '202806063278325760',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	inquiryListAudit: {
		id: '202804680240136192',
		code: 'iglobalwin',
		parentId: '386170414964943647',
		name: '询盘列表-审核',
		type: 3,
		englishName: 'inquiryListAudit',
		permissionId: '202806063278325760',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	ViewDetail: {
		id: '202747729451941888',
		code: 'iglobalwin',
		parentId: '386170414964943647',
		name: '询盘列表-查看详情',
		type: 3,
		englishName: 'inquiryListViewDetail',
		permissionId: '202753853358080000',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	inquiryListDerive: {
		id: '223831858083790848',
		code: 'iglobalwin',
		parentId: '386170414964943647',
		name: '询盘列表-询盘导出',
		type: 3,
		englishName: 'inquiryListDerive',
		permissionId: '223832153199214592',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	ChangesEdit: {
		id: '202745975914102784',
		code: 'iglobalwin',
		parentId: '386170414964943640',
		name: '任务列表-更改编辑',
		type: 3,
		englishName: 'taskListChangesEdit',
		permissionId: '204949282636169216',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	socialMediaUpdate: {
		id: '202746923235409920',
		code: 'iglobalwin',
		parentId: '386170414964943643',
		name: '社媒账号-编辑',
		type: 3,
		englishName: 'socialMediaUpdate',
		permissionId: '204956973731414016',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	tweetsDelete: {
		id: '202747328111575040',
		code: 'iglobalwin',
		parentId: '386170414964943644',
		name: '推文管理-删除帖子',
		type: 3,
		englishName: 'tweetsManagementDelete',
		permissionId: '204974278955761664',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	DeleteAccount: {
		id: '202747555975528448',
		code: 'iglobalwin',
		parentId: '386170414964943645',
		name: '授权管理-删除账号',
		type: 3,
		englishName: 'authorizationDeleteAccount',
		permissionId: '204974304104808448',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	websiteMessageSite: {
		id: '202748340662697984',
		code: 'iglobalwin',
		parentId: '386170414964943650',
		name: '网站管理-通知设置',
		type: 3,
		englishName: 'websiteMessageSite',
		permissionId: '204984744859926528',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	webSiteConfigure: {
		id: '202751336645656576',
		code: 'iglobalwin',
		parentId: '386170414964943650',
		name: '网站管理-配置',
		type: 3,
		englishName: 'webSiteConfigure',
		permissionId: '204984747468783616',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	MonitorBinding: {
		id: '202751076103880704',
		code: 'iglobalwin',
		parentId: '386170414964943650',
		name: '网站管理-监测绑定',
		type: 3,
		englishName: 'webSiteMonitorBinding',
		permissionId: '204984749268140032',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	inquiryEmail: {
		code: 'iglobalwin',
		englishName: 'inquiryEmail',
		id: '223841236916633600',
		label: '',
		name: '网站管理-询盘邮箱',
		oftenFlag: 0,
		parentId: '386170414964943650',
		permissionId: '223841305212485632',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
	accountManagement: {
		id: '202752690835423232',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-账号管理',
		type: 3,
		englishName: 'accountManagement',
		permissionId: '204984764606709760',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	accountManagementEditor: {
		id: '202752690835423232',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-系统管理员账号管理编辑',
		type: 3,
		englishName: 'accountManagementEditor',
		permissionId: '204984764606709760',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	accountManageEditorPermissions: {
		id: '202752690835423232',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-账号管理编辑',
		type: 3,
		englishName: 'accountManageEditorPermissions',
		permissionId: '204984764606709760',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	accountEdit: {
		id: '202752485285167104',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-编辑',
		type: 3,
		englishName: 'accountEdit',
		permissionId: '204984768025067520',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	accountViewDetail: {
		id: '202751995130413056',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-查看详情',
		type: 3,
		englishName: 'accountViewDetail',
		permissionId: '204984773167284224',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	accountAdd: {
		id: '202751811042410496',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-新增客户',
		type: 3,
		englishName: 'accountAdd',
		permissionId: '204984775377682432',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	orderConfirmation: {
		code: 'iglobalwin',
		englishName: 'orderConfirmation',
		id: '314073208347164672',
		label: '',
		name: '客户详情-订单确认',
		oftenFlag: 0,
		parentId: '241579367006732288',
		permissionId: '314073391915073536',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
	accountDetailReorder: {
		id: '202753187319382016',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户详情-续单',
		type: 3,
		englishName: 'accountDetailReorder',
		permissionId: '204984782046625792',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	accountDetailViewEdit: {
		id: '202753444258250752',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户详情-查看编辑',
		type: 3,
		englishName: 'accountDetailViewEdit',
		permissionId: '204984784173137920',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	delete: {
		id: '202753614010122240',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户详情-删除订单',
		type: 3,
		englishName: 'accountDetailDelete',
		permissionId: '204984786379341824',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	serviceLabelEdit: {
		id: '202753614010122240',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户详情-删除订单',
		type: 3,
		englishName: 'serviceLabelEdit',
		permissionId: '204984786379341824',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	modifyAllServiceOrder: {
		id: '202753614010122240',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '编辑全部服务单',
		type: 3,
		englishName: 'modifyAllServiceOrder',
		permissionId: '204984786379341824',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},

	// ------------------------------------
	changesStatus: {
		id: '202802056715567104',
		code: 'iglobalwin',
		parentId: '386170414964943639',
		name: '任务看板-编辑状态',
		type: 3,
		englishName: 'taskKanbanchangesStatus',
		permissionId: '205307501795606528',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	changesConductor: {
		id: '202801178759659520',
		code: 'iglobalwin',
		parentId: '386170414964943639',
		name: '任务看板-编辑处理人',
		type: 3,
		englishName: 'taskBoardChangesConductor',
		permissionId: '205307506472255488',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	changesTime: {
		code: 'iglobalwin',
		englishName: 'taskKanbanchangesTime',
		id: '202801889715159040',
		label: '',
		name: '任务看板-编辑截止时间',
		oftenFlag: 0,
		parentId: '386170414964943639',
		permissionId: '202806009570263040',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
	keywordAssistant: {
		id: '238284008180416512',
		code: 'iglobalwin',
		parentId: '238283321824509952',
		name: '市场洞察工具',
		type: 2,
		englishName: 'keywordAssistant',
		permissionId: '238286092044861440',
		sort: 2,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	googleAds: {
		code: 'iglobalwin',
		englishName: 'googleAds',
		id: '249529222828130304',
		label: '',
		name: '投放效果',
		oftenFlag: 0,
		parentId: '386170414964943631',
		permissionId: '249553075260358656',
		positionId: '395203283951554560',
		sort: 1,
		type: 1,
	},
	AdsMonitoringList: {
		code: 'iglobalwin',
		englishName: 'AdsMonitoringList',
		id: '249552120028594176',
		label: '',
		name: 'Ads监测列表',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	warningList: {
		code: 'iglobalwin',
		englishName: 'warningList',
		id: '249529600961413120',
		label: '',
		name: '预警列表',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553093337808896',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	adsAccountManagement: {
		code: 'iglobalwin',
		englishName: 'adsAccountManagement',
		id: '686976140438405120',
		label: '',
		name: 'Ads账户管理',
		oftenFlag: 0,
		parentId: '249559076625711104',
		permissionId: '690894610947375104',
		positionId: '395203283951554560',
		sort: 1,
		type: 2,
	},
	googleAdsDetail: {
		code: 'iglobalwin',
		englishName: 'googleAdsDetail',
		id: '249559076625711104',
		label: '',
		name: '查看详情',
		oftenFlag: 0,
		parentId: '386170414964943631',
		permissionId: '255659156927676416',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	accountDetection: {
		code: 'iglobalwin',
		englishName: 'accountDetection',
		id: '249559076625711104',
		label: '',
		name: '账户检测',
		oftenFlag: 0,
		parentId: '386170414964943631',
		permissionId: '255659156927676416',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	workOrder: {
		code: 'iglobalwin',
		englishName: 'workOrder',
		id: '324206931856064512',
		label: '',
		name: '工单管理',
		oftenFlag: 0,
		parentId: '386170414964943631',
		permissionId: '324208158308302848',
		positionId: '395203283951554560',
		sort: 1,
		type: 1,
	},
	workOrderSubmitted: {
		code: 'iglobalwin',
		englishName: 'workOrderSubmitted',
		id: '324207315920093184',
		label: '',
		name: '我提交的工单',
		oftenFlag: 0,
		parentId: '324206931856064512',
		permissionId: '324208163983196160',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	workOrderNeedTodo: {
		code: 'iglobalwin',
		englishName: 'workOrderNeedTodo',
		id: '324207442990727168',
		label: '',
		name: '需要我处理的工单',
		oftenFlag: 0,
		parentId: '324206931856064512',
		permissionId: '324208166650773504',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	workOrderAll: {
		code: 'iglobalwin',
		englishName: 'workOrderAll',
		id: '324207754182918144',
		label: '',
		name: '全部工单',
		oftenFlag: 0,
		parentId: '324206931856064512',
		permissionId: '324208169247047680',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	kit: {
		code: 'iglobalwin',
		englishName: 'kit',
		id: '332939798568239104',
		label: '',
		name: '工具',
		oftenFlag: 0,
		parentId: '386170414964943631',
		permissionId: '332941108080279552',
		positionId: '395203283951554560',
		sort: 1,
		type: 1,
	},
	evaluation: {
		code: 'iglobalwin',
		englishName: 'customerEvaluate',
		id: '332940075413274624',
		label: '',
		name: '客户评价',
		oftenFlag: 0,
		parentId: '332939798568239104',
		permissionId: '332941114224934912',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	keyWordReports: {
		code: 'iglobalwin',
		englishName: 'keyWordReports',
		id: '756190228208680960',
		label: '',
		name: '网站关键词报告',
		oftenFlag: 0,
		parentId: '332956166625689600',
		permissionId: '756191188091928576',
		positionId: '395203283951554560',
		sort: 1,
		type: 2,
	},
	taskKanbanViewAll: {
		id: '202803420610953216',
		code: 'iglobalwin',
		parentId: '386170414964943639',
		name: '任务看板-查看全部',
		type: 3,
		englishName: 'taskKanbanViewAll',
		permissionId: '202806012732768256',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	taskListViewAll: {
		id: '202803602283036672',
		code: 'iglobalwin',
		parentId: '386170414964943640',
		name: '任务列表-查看全部',
		type: 3,
		englishName: 'taskListViewAll',
		permissionId: '202806022811680768',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	socialMediaAccountViewAll: {
		id: '202803889471225856',
		code: 'iglobalwin',
		parentId: '386170414964943643',
		name: '社媒账号-查看全部',
		type: 3,
		englishName: 'socialMediaAccountViewAll',
		permissionId: '202806040171905024',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	authorizationViewAll: {
		id: '202804436295221248',
		code: 'iglobalwin',
		parentId: '386170414964943645',
		name: '授权管理-查看全部',
		type: 3,
		englishName: 'authorizationViewAll',
		permissionId: '202806050187902976',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	customerListViewAll: {
		id: '202805229484244992',
		code: 'iglobalwin',
		parentId: '386170414964943654',
		name: '客户列表-查看全部',
		type: 3,
		englishName: 'customerListViewAll',
		permissionId: '202806079631917056',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	websiteViewAll: {
		id: '202804807461765120',
		code: 'iglobalwin',
		parentId: '386170414964943650',
		name: '网站管理-查看全部',
		type: 3,
		englishName: 'websiteViewAll',
		permissionId: '202806111537987584',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	tweetManagementViewAll: {
		id: '202804188634152960',
		code: 'iglobalwin',
		parentId: '386170414964943644',
		name: '推文管理-查看全部',
		type: 3,
		englishName: 'tweetManagementViewAll',
		permissionId: '204948464440705024',
		sort: 4,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	resultsReportViewAll: {
		code: 'iglobalwin',
		englishName: 'resultsReportViewAll',
		id: '246621637623939072',
		label: '',
		name: '成效报告-查看全部',
		oftenFlag: 0,
		parentId: '246620753645010944',
		permissionId: '246621714107072512',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
	industruReport: {
		id: '259305238907846656',
		code: 'iglobalwin',
		parentId: '238281168800186368',
		name: '行业效果报告',
		type: 2,
		englishName: 'industruReport',
		permissionId: '259306625855127552',
		sort: 3,
		oftenFlag: 0,
		label: '',
		positionId: '395203283951554560',
	},
	newUserOnline: {
		code: 'iglobalwin',
		englishName: 'newUserOnline',
		id: '249552120028594176',
		label: '',
		name: '新用户上线方案',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	extensionTermManagement: {
		code: 'iglobalwin',
		englishName: 'extensionTermManagement',
		id: '249552120028594176',
		label: '',
		name: '拓词管理',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	targetCustomerMatching: {
		code: 'iglobalwin',
		englishName: 'targetCustomerMatching',
		id: '249552120028594176',
		label: '',
		name: '目标客户匹配',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 2,
	},
	TCMDownloadIndustryPackages: {
		code: 'iglobalwin',
		englishName: 'TCMDownloadIndustryPackages',
		id: '249552120028594176',
		label: '',
		name: '目标客户匹配-下载行业包',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	TCMViewDetails: {
		code: 'iglobalwin',
		englishName: 'TCMViewDetails',
		id: '249552120028594176',
		label: '',
		name: '目标客户匹配-查看详情',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	TCMDownloadTheReport: {
		code: 'iglobalwin',
		englishName: 'TCMDownloadTheReport',
		id: '249552120028594176',
		label: '',
		name: '目标客户匹配-下载报告',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	TCMAds: {
		code: 'iglobalwin',
		englishName: 'TCMAds',
		id: '249552120028594176',
		label: '',
		name: '目标客户匹配-数据同步Ads',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	TCMUpdateOfEligibility: {
		code: 'iglobalwin',
		englishName: 'TCMUpdateOfEligibility',
		id: '249552120028594176',
		label: '',
		name: '目标客户匹配-使用资格更新',
		oftenFlag: 0,
		parentId: '249529222828130304',
		permissionId: '249553080960417792',
		positionId: '395203283951554560',
		sort: 2,
		type: 3,
	},
	startService: {
		code: 'iglobalwin',
		englishName: 'startService',
		id: '826478396270706688',
		label: '',
		name: '客户详情-开始服务',
		oftenFlag: 0,
		parentId: '238628358462636032',
		permissionId: '826480544484163584',
		positionId: '395203283951554560',
		sort: 3,
		type: 3,
	},
};
